// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import LoadingController from "./loading_controller"
application.register("loading", LoadingController)

import ModalController from "./modal_controller"
application.register("modal", ModalController)

import PrivacyConsentController from "./privacy_consent_controller"
application.register("privacy-consent", PrivacyConsentController)

import ParallaxController from "./parallax_controller"
application.register("parallax", ParallaxController)

import ScrollBehaviorController from "./scroll_behavior_controller"
application.register("scroll-behavior", ScrollBehaviorController)

import SwiperController from "./swiper_controller"
application.register("swiper", SwiperController)

import TabController from "./tab_controller"
application.register("tab", TabController)

import EntryFormController from "./entry_form_controller"
application.register("entry-form", EntryFormController)

import InternDateSelectorController from "./intern_date_selector_controller"
application.register("intern-date-selector", InternDateSelectorController)
